export default __webpack_public_path__ + "static/image15-fedf3c36fac1db8304ef3e111d2dc0fa.jpg";